import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
